var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17647",
    "data-name": "Group 17647",
    transform: "translate(-632 -695)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_587",
    "data-name": "Ellipse 587",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(632 695)",
    fill: "#dfefec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ID_Card_approved",
    "data-name": "ID Card approved",
    transform: "translate(639 701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17583",
    "data-name": "Group 17583",
    transform: "translate(1 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19543",
    "data-name": "Path 19543",
    d: "M20.822,5H6.139a2.208,2.208,0,0,0-2.2,2.2v.733H3.2a2.208,2.208,0,0,0-2.2,2.2v8.8a2.208,2.208,0,0,0,2.2,2.2H17.885a2.208,2.208,0,0,0,2.2-2.2V18.2h.734a2.208,2.208,0,0,0,2.2-2.2V7.2A2.208,2.208,0,0,0,20.822,5Zm-2.2,13.935a.736.736,0,0,1-.734.733H3.2a.736.736,0,0,1-.734-.733v-8.8A.736.736,0,0,1,3.2,9.4H17.885a.736.736,0,0,1,.734.733ZM21.556,16a.736.736,0,0,1-.734.733h-.734v-6.6a2.208,2.208,0,0,0-2.2-2.2H5.4V7.2a.736.736,0,0,1,.734-.733H20.822a.736.736,0,0,1,.734.733Z",
    transform: "translate(-1 -5)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19544",
    "data-name": "Path 19544",
    d: "M10.283,16.934a2.52,2.52,0,1,0-4.166,0A4.186,4.186,0,0,0,4,20.559a.84.84,0,0,0,.84.84h6.72a.84.84,0,0,0,.84-.84,4.186,4.186,0,0,0-2.117-3.625ZM7.36,15.519a.84.84,0,1,1,.84.84A.84.84,0,0,1,7.36,15.519Zm-1.536,4.2a2.521,2.521,0,0,1,4.753,0Z",
    transform: "translate(-1.48 -7.842)",
    fill: "#0c263d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19545",
    "data-name": "Path 19545",
    d: "M20.527,14.759l-2.494,2.969-.751-.894a.726.726,0,1,0-1.112.934l1.307,1.556a.726.726,0,0,0,1.112,0l3.05-3.631a.726.726,0,1,0-1.112-.934Z",
    transform: "translate(-4.655 -8.005)",
    fill: "#0c263d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.446631704c71fbf562076ce9099a6513.svg";
export { ForwardRef as ReactComponent };